import React from 'react';

import { CallMedium } from '../../../../Enums/ActivityEnum';

export interface CallHistoryRowProps<ActionItem> {
  id: string;
  menuListStyle?: React.CSSProperties;
  avatarClassName?: any;
  style?: React.CSSProperties;
  contactName: string;
  callFailed?: boolean;
  callUnwrapped?: boolean;
  callDirection: CallDirection;
  callMedium: CallMedium;
  date: string;
  time: string;
  duration: string;
  actions: Array<ActionItem>;
  getActionNode: (action: ActionItem, style: React.CSSProperties, item?: any) => React.ReactNode;
  showActionsOverflowTooltip?: boolean;
  getActionsOverflowCountTooltipContent?: (overflowItems: Array<any>) => React.ReactChild;
  showNavigationNode?: boolean;
  showCallActionButton?: boolean;
  showNavNodeOnHover?: boolean;
  navigationNode?: React.ReactNode;
  miniVersion?: React.ReactNode;
  item?: Object;
  callButtonDisabled?: boolean;
  getMenuItems: (data: any) => Array<any>;
  onCall: (callbackValue?: any) => any;
  onHistoryRowClick?: (item?: any) => any;
  onAvatarClick?: (item?: any) => any
};

export enum CallDirection {
  outbound = 'outbound',
  inbound = 'inbound',
};

export enum StatusType {
  inboundMissed = 'inbound-missed',
  inboundReceived = 'inbound-received',
  outboundMissed = 'outbound-missed',
  outboundReceived = 'outbound-received',
};
